import { Html, Head, Body, Container, Section, Text, Hr, Img } from '@react-email/components';
import type { ReactNode } from 'react';

interface Props {
  preheader: string;
  children: ReactNode;
}

export default function EmailLayout({ preheader, children }: Props) {
  return (
    <Html lang="en-AU">
      <Head>
        <title>InnovateX</title>
      </Head>
      <Body
        style={{
          backgroundColor: '#f5f5f4',
          fontFamily: "'Manrope', 'Rethink Sans', Helvetica, Arial, sans-serif",
          color: '#1f2937',
        }}
      >
        <div
          style={{
            display: 'none',
            overflow: 'hidden',
            lineHeight: '1px',
            opacity: 0,
            maxHeight: 0,
            maxWidth: 0,
          }}
        >
          {preheader}
        </div>
        <Container style={{ maxWidth: 600, margin: '0 auto', padding: 24, background: '#fff' }}>
          <Section>
            <Img
              src="https://innovatexsolutions.com.au/images/logo-light-mode.svg"
              alt="InnovateX"
              width={160}
            />
          </Section>
          <Section>{children}</Section>
          <Hr />
          <Section>
            <Text style={{ fontSize: 12, color: '#666' }}>
              InnovateX Solutions Pty Ltd · Brisbane, Australia
              <br />
              You are receiving this email because you completed an InnovateX assessment.
            </Text>
          </Section>
        </Container>
      </Body>
    </Html>
  );
}
